
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`Quels sont ses points faibles?`}</em></p>
    <p>{`Les informations validées par des experts indépendants ont longtemps fait défaut
pour les vaccins provenant de Chine. Les données préliminaires qui ont été
fournies ont toutefois permis à l'OMS de valider ce produit, de même qu'un autre
vaccin chinois (voir dans la catégorie "des petits frères").`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;